import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { ApplicationState } from '../../store';
import { TeamRole } from '../../store/Models/UserContext';
import { ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';

import './styles.css';

// ===============================================================================

type StartSurveyGuideProps = RouteComponentProps & ToxnotComponentProperties;

//
// Sub start component for the survey guide.
//
class StartSurveyGuide extends ToxnotSignInRequiredComponent<StartSurveyGuideProps> {

    public constructor(props: StartSurveyGuideProps) {
        super(props);
    }

    // ===============================================================================

    public componentDidUpdate() {
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [TeamRole.Marketing];
    }

    // ===============================================================================

    public renderConcreteComponent() {
        return (
            <div id="start-report-content" className="start-content">
                <div className="left-content">
                    <div className="start-subcontent-heading">
                        {this.localizeString("Why should I request data from a supplier?")}
                    </div>
                    <p className="start-subcontent-content-container">
                        {this.localizeString("Making your products safe, sustainable & compliant starts with truly knowing your supply chain.")}
                    </p>
                    <p className="start-subcontent-content-container">
                        {this.localizeString("Are you trying to prove product compliance (ex. Conflict Minerals, Cal Prop 65, REACH, RoHS, or Red List Free)? Or create sustainability reports such as a Declare Labels or HPDs? Maybe you’re trying to create transparency throughout your supply chain or put your ESG goals into action.")}
                    </p>
                    <p className="start-subcontent-content-container">
                        {this.localizeString("The most robust way to answer these questions is to know the entire composition of your products. Determining any kind of compliance relies on knowing if your sub-components are compliant.")}
                    </p>
                    <p className="start-subcontent-content-container">
                        {this.localizeString("This requires asking your suppliers questions. Email is slow, disorganized and inefficient. Instead, request data via Product & Material Passports on the Passport Library to better collect and organize your data.")}
                    </p>
                    <p className="start-subcontent-content-container" style={{ marginBottom: "40px" }}>
                        <a href="https://content.toxnot.com/supplier-survey-guide" className="btn btn-tn-action-complement">{this.localizeString("Check out our Full Guide")} <span className="glyphicon glyphicon-chevron-right"></span></a>
                    </p>
                    <div className="start-subcontent-heading">
                        {this.localizeString("How do I request data from a supplier?")}
                    </div>
                    <p className="start-subcontent-content-container">
                        {this.localizeString("It's easy to get started. Just add your suppliers and their emails, define the materials you're interested in, and 3E Exchange will automatically send requests to your Suppliers.")}
                    </p>
                    <p className="start-subcontent-content-container">
                        {this.localizeString("Your Suppliers will use 3E Exchange to create Product & Material Passports. You'll get automatically notified when the Passports are ready to view.")}
                    </p>
                    <p className="start-subcontent-content-container">
                        <button role="button" className="btn btn-tn-action-complement" onClick={this.goToInviteSuppliersButton_click}>{this.localizeString("Request Data")} <span className="glyphicon glyphicon-chevron-right"></span></button>
                    </p>
                </div>
            </div>
        );
    }

    private goToInviteSuppliersButton_click = () => {
        this.props.history.push("/Start/InviteSuppliers");
    }
}

// ===============================================================================

export default connect(
    (state: ApplicationState) => ({ appServices: state.appServices })
)(withRouter(StartSurveyGuide) as any);
